export const bg = {
  returnLineItems: {
    refund: "Възстановяване",
    exchange: "Замяна",
    discount: "Отстъпка",
  },
  returnStoreAddress: {
    mapButton: "Виж на картата",
  },
  downloadLabel: {
    label: "Изтегли етикета ми",
    bonDeRetour: "Изтегли формуляра за връщане",
  },
  returnRequestDate: {
    label: "Заявката ви за връщане е направена на {{date}} в {{time}}",
  },
  actions: {
    continue: "Продължи",
  },
  "order-identification": {
    title: "Проследете поръчката си",
    description:
      "Въведете детайлите на поръчката си, за да проследите пратката",
    fields: {
      "zip-code": {
        title: "Пощенски код",
        description: "Въведете вашия пощенски код за доставка",
        required: "Пощенският код е задължителен",
      },
      email: {
        title: "Имейл адрес",
        description: "Въведете имейл адреса, използван при поръчката",
        required: "Имейл адресът е задължителен",
      },
      both: {
        title: "Пощенски код или имейл",
        description: "Въведете вашия пощенски код за доставка или имейла, използван за поръчката",
        required: "Пощенският код или имейлът е задължителен",
      },
      "tracking-number": {
        title: "Номер на поръчка",
        description: "Въведете номера на поръчката си",
        required: "Номерът на поръчката е задължителен",
      },
    },
    errors: {
      "unknown-order": {
        title: "Неизвестен номер на поръчка",
        description: "Номерът на поръчката не беше намерен, моля проверете го",
      },
      "search-error": {
        title: "Грешка при търсене",
        description:
          "Не успяхме да намерим поръчката. Моля, опитайте по-късно.",
      },
    },
  },
  delivery: "Доставка",
  "parcel-history": "История на пратката",
  "order-details": {
    title: "Детайли на поръчката",
    "tracking-number": "Номер за проследяване",
    "order-number": "Номер на поръчка",
  },
  tracking: {
    shared: {
      estimatedDeliveryDate: "Очаквана дата на доставка",
      deliveredOn: "Доставено на",
      from: "от",
      to: "до",
    },
  },
  deliveryAddress: {
    title: "Адрес за доставка:",
    titlePickup: "Адрес на пункта за получаване:",
    orderDetails: {
      title: "Детайли на поръчката:",
      trackingNumber: "Номер за проследяване:",
      orderNumber: "Номер на поръчката:",
      orderDate: "Дата на поръчката:",
    },
  },
  pickupPoint: {
    title: "Пункт за получаване",
    openingHours: "Работно време:",
    closed: "Затворено",
    directions: "Указания",
    days: {
      monday: "Понеделник:",
      tuesday: "Вторник:",
      wednesday: "Сряда:",
      thursday: "Четвъртък:",
      friday: "Петък:",
      saturday: "Събота:",
      sunday: "Неделя:",
    },
  },
  wallet: {
    warningNotEnabled:
      "Трябва да активирате Wallet в настройките на вашия магазин",
  },
  crossSell: {
    youMightAlsoLike: "Може да харесате и",
  },
  "rate-order": {
    "order-recap": {
      title: "Вашата поръчка",
      "tracking-label": "Номер за проследяване:",
      "order-label": "Номер на поръчка:",
    },
    form: {
      title: "Оценете вашата доставка",
      "rating-label": "Оценете опита си с доставката",
      "comment-label": "Коментар (незадължително)",
      "comment-placeholder": "Споделете опита си с нас…",
      "submit-cta": "Изпрати моята оценка",
      "update-cta": "Обнови моята оценка",
      "rating-required": "Моля, изберете оценка.",
    },
    "thank-you": {
      title: "Благодарим за вашата обратна връзка!",
      description:
        "Вашата оценка беше запазена. Тя ще ни помогне да подобрим опита с доставките.",
    },
    errors: {
      "invalid-token": {
        title: "Невалидна или изтекла връзка",
        description:
          "Тази връзка вече не е валидна. Моля, отворете я отново от последния си имейл за проследяване.",
      },
      submit: {
        title: "Нещо се обърка",
        description:
          "Не успяхме да запазим вашата оценка. Моля, опитайте по-късно.",
      },
    },
  },
  shippingInstructions: {
    colissimo: "Вече можете да отпечатате етикета за връщане и да оставите пратката си в най-близкия пункт на Colissimo.",
    chronoShop2Shop: "Вече можете да отпечатате етикета за връщане и да оставите пратката си в най-близкия пункт на Chronopost.",
    ups: "Вече можете да отпечатате етикета за връщане и да оставите пратката си в най-близкия пункт на UPS.",
    customerCarrier: "Вече можете да изпратите пратката за връщане с превозвач по ваш избор.",
    merchantCarrier: "Ще ви изпратим етикет за връщане по имейл в рамките на 1 до 3 работни дни.",
    returnToStore: "Вече можете да оставите пратката си в най-близкия магазин.",
    malca: "Вече можете да отпечатате етикета за връщане и да оставите пратката си в най-близкия пункт на Malca.",
    tnt: "Вече можете да отпечатате етикета за връщане и да оставите пратката си в най-близкия пункт на TNT.",
    bonDeRetour: "Вашата бележка за връщане е готова. Вече можете да я отпечатате и да я използвате за връщането.",
  },
  shippingInstructionsTitle: {
    shippingLabel: "Вашият транспортен етикет е готов",
    bonDeRetour: "Вашата бележка за връщане е готова",
  },
} as const;
